import { Component, inject, OnInit } from '@angular/core';
import { TranslocoRootModule } from '../../transloco-root.module';
import { watchIsLoggedIn, login, logout } from 'shell-browser/auth.js';
import { NgShellRxjsWrapperService } from '../../shell/ng-shell-wrapper.service';
import { Observable, debounceTime, distinctUntilChanged } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NotificationSearchComponent } from '../notification-search/notification-search.component';
import { OneWebComponentsAngularModule } from '@one/angular';
import { NotificationFilterComponent } from '../notification-filter/notification-filter.component';
import { NotificationTableComponent } from '../notification-table/notification-table.component';
import { CustomerNotificationService } from './customer-notification.service';
import { Router } from '@angular/router';
import { LinkService } from '../../core/services/link.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  standalone: true,
  imports: [TranslocoRootModule, NotificationSearchComponent, OneWebComponentsAngularModule, NotificationFilterComponent, NotificationTableComponent],
})

export class MainPageComponent implements OnInit {
  readonly ngShellService = inject(NgShellRxjsWrapperService);
  customerservice = inject(CustomerNotificationService);
  http = inject(HttpClient);
  router = inject(Router);
  linkService: LinkService = inject(LinkService);
  isLoggedIn$: Observable<boolean>;
  isLoggedIn: boolean = false;
  loading: boolean = false;
  notificationsList: any;
  accSelected: string;
  filterOptions: { types: string[]; statuses: string[] } 
  filterOptSel: { types: string[]; statuses: string[] } 
  searchValueSel: any;
  spinBool:boolean = false;
  
  ngOnInit(): void {

    const requestedNotification = this.getRequestedNotificationFromUrl();
    if (requestedNotification) {
      this.redirectToRequestedNotification(requestedNotification);
      return;
    }

    this.getIsLoggedIn();

    this.isLoggedIn$
    .pipe(
        distinctUntilChanged(), // Only emit when value changes
        untilDestroyed(this)
      )
    .subscribe(async isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
      if (isLoggedIn) {
        this.performLoggedInActions();
      }else {
        this.performLoggedOutActions();
      }
    });
  }

  private getRequestedNotificationFromUrl(): any {
    const urlQueryString = window.location.search;
    const parameters = new URLSearchParams(urlQueryString);

    // Set parameters to lower case to avoid issues
    const lowerCaseParameters = new Map<string, string>();
    if (parameters.size) {
      parameters.forEach((value, key) => {
        lowerCaseParameters.set(key.toLowerCase(), value);
      });
    }

    if (lowerCaseParameters.get('notificationid')) {
      const requestedNotification = {
        notificationId: lowerCaseParameters.get('notificationid'),
        contactNotificationId: lowerCaseParameters.get('contactnotificationid'),
        publicKeyToken: lowerCaseParameters.get('publickeytoken'),
        country: lowerCaseParameters.get('country'),
        lang: lowerCaseParameters.get('lang')
      }
      return requestedNotification;
    }
  }

  private redirectToRequestedNotification(requestedNotification: any): void {
    var viewUrl = 'customer-notification-details';
    if (requestedNotification.country && requestedNotification.lang) {
      viewUrl = `${requestedNotification.country}/${requestedNotification.lang.replace('_', '-')}/${viewUrl}`;
    }
    this.router.navigate([viewUrl], { 
      queryParams: { 
        publicKeyToken: requestedNotification.publicKeyToken,
        notificationId: requestedNotification.notificationId,
        contactNotificationId: requestedNotification.contactNotificationId,
      } });
  }
  
  private getIsLoggedIn(): void {
    this.isLoggedIn$ = this.ngShellService.toObservable(watchIsLoggedIn);
  }

  private async performLoggedInActions(): Promise<void> {
    this.spinBool = true;
    await this.getNotificationDetails();
  }

  private performLoggedOutActions(): void {
  }

  private getNotificationDetails(): void {
    this.customerservice.accountSelector$.subscribe(
      res => {
        this.accSelected = res;
        if(res === 'My notifications'){
          this.customerservice.getNotificationTableData(['all'],['all']).pipe(debounceTime(500)).subscribe(
            (data) => {
              this.notificationsList = data;
              this.filterOptions = this.extractFilters(data);
              this.loading = true;
              this.spinBool = false;
            }
          );
        }else{
          this.customerservice.getAccountDetails(res,['all'],['all']).pipe(debounceTime(500)).subscribe(
            (data) => {
              this.notificationsList = data;
              this.filterOptions = this.extractFilters(data);
              this.loading = true;
              this.spinBool = false;
            }
          );
        }
      },
      err => {
        this.spinBool = false;
        console.log(err,'error for getNotificationDetails');
      }
    );
  }

  extractFilters(data: any[]): { types: string[], statuses: string[] } {
    return  {
      types: this.extractTypes(data),
      statuses: this.extractStatuses(data)
    }
  }

  private  extractTypes(data: any[]): string[] {
    const types = data.map(item => item.Type);
    return Array.from(new Set(types));
  }

  private extractStatuses(data: any[]): string[] {
    const statuses = data.map(item => (item.CustomerStatus || item.Status));
    return [...Array.from(new Set(statuses)), 'Completed'];
  }

  filterOptInp(data){
    this.filterOptSel = data;
  }

  searchValueInp(data){
    this.searchValueSel = data;
  }
}
